<div class="header-container" [style]="openWindow ? 'background: black' : '' ">
  <div class="header-content">
    <div class="header-content-left">
      <div class="header-content-left-icon">
        <app-icon [icon]="Icons.logoHeader" />
      </div>
      <div class="header-content-left-text">
        <div class="header-content-left-title">
          GOLD STAR SPORTS MANAGEMENT GROUP
        </div>
        <div class="header-content-left-subtitle">
          A DIVISION OF THE GOLD STAR FAMILY OF COMPANIES
        </div>
      </div>
    </div>
    <div class="header-content-right">
      <div *ngFor="let item of items">
        <div
          class="header-right-el"
          (click)="onSectionClick(item.sectionId)"
          [class]="sectionService.getActiveSection() === item.sectionId ? 'header-right-el-active' : ''"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="header-content-menu">
      <div *ngIf="!openWindow" style="width: 30px; height: 20px;" (click)="openWindow = true">
        <app-icon [icon]="Icons.menu"/>
      </div>
      <div *ngIf="openWindow" style="width: 33px; height: 33px;" (click)="openWindow = false">
        <app-icon [icon]="Icons.cross"/>
      </div>
      <div *ngIf="openWindow" class="header-content-menu-window">
        <div *ngFor="let item of items">
          <div
            class="header-right-el"
            (click)="onSectionClick(item.sectionId)"
            [class]="sectionService.getActiveSection() === item.sectionId ? 'header-right-el-active' : ''"
          >
            {{ item.label }}
          </div>
        </div>
        <div class="header-content-menu-window-logo-container">
          <div class="header-content-menu-window-logo-container-icon">
            <app-icon [icon]="Icons.logoHeader"/>
          </div>
          <p style="margin-top: 0.5rem">Gold Star Sports Management</p>
          <p>2350 Green Road. Suite 100B</p>
          <p>Ann Arbor, Michigan 48105</p>
<!--          <a download [href]="file" style="margin-top: 0.5rem">Скачать презентацию о компании</a>-->
        </div>
      </div>
    </div>
  </div>
</div>
